export default __webpack_public_path__ + "static/media/frg--outdoor-lagoon-pool.42861c3d.png";